import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
const $=window.$;

class PracticewiseComp extends Component {
	constructor(props) {
		super(props);

        this.state={ 
          records_score : [],
          old_id : '',
          old_idd : '',
          old_parent : '',
          oldpr_id : '',
          oldpr_idd : '',
          oldpr_parent: '',
        };
        this.getBack = this.getBack.bind(this);
        this.getBottom = this.getBottom.bind(this);
        this.getSubbottom = this.getSubbottom.bind(this);

	}	

  componentWillReceiveProps(nextProps) {
  }

  getSubbottom(pr_id,pr_idscr,id_practice){
    let oldpr_id = this.state.oldpr_id;
    let oldpr_idd = this.state.oldpr_idd;
    let oldpr_parent = this.state.oldpr_parent;
    $('#'+pr_idscr).addClass('selected');
    $('#'+pr_id+' #'+id_practice).show();
    if(oldpr_parent != '')
    {
      $('#'+oldpr_id).removeClass('selected');
      $('#'+oldpr_parent+' #'+oldpr_idd).hide();
    }
    if(oldpr_idd == id_practice){
      $('#'+pr_idscr).addClass('selected');
      $('#'+pr_id+' #'+id_practice).show();
    }
    this.setState({
      oldpr_id : pr_idscr,
      oldpr_idd : id_practice,
      oldpr_parent:pr_id,
    })
  }

  getBottom(id,id_scr,id_score){
    let old_id = this.state.old_id;
    let old_idd = this.state.old_idd;
    let old_parent = this.state.old_parent;
    $('#'+id_scr).addClass('selected');
    $('#'+id+' .submenu').show();
    if(old_parent != '')
    {
      $('#'+old_id).removeClass('selected');
      $('#'+old_parent+' .submenu').hide();
    }
    if(old_idd = id_score){
      $('#'+id_scr).addClass('selected');
      $('#'+id+' .submenu').show();  
    }
    this.setState({
      old_id : id_scr,
      old_idd : id_score,
      old_parent:id,
    })
  }

  getBack(type){
    this.props.switchPanel(type);
  }

  getPractice(){
    let page_flag= '';
    let learnerID = Common.getUserData("id", true);
    let practiceCorner = Common.getUserData("practiceCorner", true);
    let practiceCornerMini = Common.getUserData("practiceCornerMini", true);
    //alert(practiceCorner+'--'+practiceCornerMini);
    if(practiceCorner != false){
       page_flag = 1;
    } else if(practiceCornerMini != false){
       page_flag = 2;
    } else{

    }
    
    Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl+'practice/practice-wise', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':'Bearer ' +Common.getTokenData()
            },
              body: JSON.stringify({
                learnerID:learnerID,
                flag:page_flag,
              })
            }).then((response) => response.json())
           .then((responseJson) => {
            Common.reactLoader("hide");
            if(responseJson.status != 0){
             this.setState({
              records_score : responseJson.records,
             });
            }

            Common.downTabClose();
        });
  }

	componentDidMount() {
    this.getPractice();	
	}

	
		render() {
      
      let records_data = this.state.records_score.map((rec_score,k)=>{
        let id =k+1;
        let id_scr = 'scr_'+id;
        let id_score = 'score_'+id;
        let group_data = '';
        if(rec_score.groups!=undefined){
          group_data = rec_score.groups.map((grp_score,ke)=>{
            let pract = ke+1;
            let id_practice = 'practice_'+pract;
            let prac_data = '';
            if(grp_score.practices!=undefined){
              prac_data = grp_score.practices.map((pra_score,key)=>{
                return(
                    <ul key={`prascore_${key}`} id={id_practice} className="subpractice practice-wise">
                      <li>
                        <p>
                            <span><a href="javascript:void(0);">{pra_score.pr_name}</a></span>
                            <span className="score-icon1">Score  <i>{(pra_score.pr_score>0)?pra_score.pr_score:'0'}</i></span>
                          </p>
                      </li>
                    </ul>
                  )
              })
            }
            return(
                <div key={`grpscore_${ke}`} className="submenu" id={id_score} style={{display:'none'}} onClick={(e)=>this.getSubbottom(id,id_score,id_practice)}>
                  <section className="viewport">
                      <section id="module-wise">
                        <ul>
                          <li className="accordion">
                            <a href="javascript:void(0);">
                                <div className="num">{grp_score.sno}</div>                          
                                  <div className="txt">{grp_score.group}</div>
                                  <span className="score-icon">Score  <i>{(grp_score.group_score>0)?grp_score.group_score:'0'}</i></span>
                              </a>
                              {prac_data}
                          </li>
                        </ul>
                      </section>
                  </section>
                </div>
              )
          })
        }
        return(
          <div key={`score_${k}`} id={id}>
            <div className="silverheader" id={id_scr} onClick={(e)=>this.getBottom(id,id_scr,id_score)}>
                <a href="javascript:void(0);" className="guide">
                <span>{rec_score.title}
                 <font>Score  <i>{(rec_score.over_score>0)?rec_score.over_score:'0'}</i> </font></span>                                 
              </a>
            </div>
            {group_data}
          </div>
          )
      })


		return (
        
      <section id="" className="contentarea main-inner practicescore scoreround">
        <div className="border-box">
          <div className="title-bg">
            <h1> <span> <img src={process.env.PUBLIC_URL+'/images/img-lr1.png'} align="absmiddle" alt="" border="0" /> </span>
              <span className="subtitle">Practice Score - Total Practice report submitted</span></h1>
              <a nohref="true" onClick={(e)=>this.getBack('PracticeNokia')}>Back to Practice Corner</a>  
          </div>

          <section id="semana-scroll-inner" className="scrollbar">
      
            <section className="viewport">
              <section className="overview">
                <div className="inner-content">
                  <section className="">    
                      <div className="applemenu">
                      {records_data}
                      </div>
                  </section>
                </div>
              </section>
            </section>

          </section>
        </div>
      </section>


			);

		}
}

export default PracticewiseComp;



// WEBPACK FOOTER //
// ./src/practice/PracticewiseComp.js